export default __webpack_public_path__ + "static/media/enchai.611e6c9c.svg";